/** @format */

import axios from "axios";

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

axios.defaults.headers.common["Accept"] = "application/json";
// Note: Don't set default Content-Type globally as it can interfere with file uploads
// Content-Type should be set per-request based on the request type

// NOT BEING PASSED FOR SOME REASON
// if (localStorage.getItem("token") != null) {
//   axios.defaults.headers.common[
//     "Authorization"
//   ] = `Bearer ${localStorage.getItem("token")}`;
// }
